import React, { ButtonHTMLAttributes, DetailedHTMLProps, ReactNode } from 'react';
import { twMerge } from 'tailwind-merge';
import { Spin } from 'src/components/svg/General';
import './styles.css';

export interface Props extends DetailedHTMLProps<
  ButtonHTMLAttributes<HTMLButtonElement>,
  HTMLButtonElement
> {
  mode?: Mode;
  disabled?: boolean;
  label?: string;
  className?: string;
  spinOnCenter?: boolean;
  children?: ReactNode;
  loading?: boolean;
  icon?: ReactNode;
  leftIcon?: ReactNode;
  classNameSvg?: string;
  ariaLabel?: string;
}

type Mode =
  | 'button-primary'
  | 'button-secondary'
  | 'button-simple'
  | 'button-transparent'
  | 'button-tertiary';

export const Button = React.forwardRef(
  (
    {
      mode = 'button-primary',
      className,
      disabled,
      label,
      children,
      onClick,
      loading,
      icon,
      leftIcon,
      classNameSvg,
      spinOnCenter = false,
      ...restProps
    }: Props,
    ref?: React.ForwardedRef<HTMLButtonElement>
  ) => {
    return (
      <button
        ref={ref}
        {...restProps}
        className={twMerge('btn h-[40px]', mode, className)}
        disabled={disabled}
        onClick={onClick}>
        {leftIcon}
        {loading && <Spin className={classNameSvg} spinOnCenter={spinOnCenter} />}
        {children ? children : label}
        {icon}
      </button>
    );
  }
);

Button.displayName = 'Button';
